const STAKES_SORT_TYPES = {
  ASCENDING: 0,
  DESCENDING: 1,
};

const STAKES_SORT_KEYS = {
  TOKEN_NAME: 0,
  VALUE: 1,
  WALLET: 2,
  TRANSACTION_HASH: 3,
  START_DATE: 4,
  END_DATE: 5,
  STATUS: 6,
};

const sortTypes = [
  {
    name: 'Ascending',
    icon: 'BiSortUp',
  },
  {
    name: 'Descending',
    icon: 'BiSortDown',
  },
];

const sortKeys = [
  {
    name: 'Token Symbol',
    key: 'symbol',
    type: 'string',
    defaultSortType: STAKES_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Value',
    key: 'value',
    type: 'number',
    defaultSortType: STAKES_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Wallet Address',
    key: 'wallet',
    type: 'string',
    defaultSortType: STAKES_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Txn Hash',
    key: 'tx_hash',
    type: 'string',
    defaultSortType: STAKES_SORT_TYPES.ASCENDING,
  },
  {
    name: 'Start Date',
    key: 'start_lock_time',
    type: 'date',
    defaultSortType: STAKES_SORT_TYPES.DESCENDING,
  },
  {
    name: 'End Date',
    key: 'udate',
    type: 'date',
    defaultSortType: STAKES_SORT_TYPES.DESCENDING,
  },
  {
    name: 'Status',
    key: 'claim_status',
    type: 'boolean',
    defaultSortType: STAKES_SORT_TYPES.DESCENDING,
  },
];

const stakesQuickFilterConstants = {
  ALL: 1,
  STAKED: 2,
  DONE: 3,
};

export {
  STAKES_SORT_KEYS,
  STAKES_SORT_TYPES,
  sortTypes,
  sortKeys,
  stakesQuickFilterConstants,
};
